import { useState } from 'react';
import Card from '../../cards/card';
import HeaderInfoCard from '../../cards/v2/info-card/header.info-card';
import { styles } from '../../cards/v2/info-card/styles';
import MembersList from '../../lists/member.list';
import HTab from '../../navigation/tabs/htab';
import { MEMBERS_TAB_OPTIONS } from '../../navigation/tabs/tab-options';

type Props = {
  id: string;
  close: Function;
};

export default function MembersView({ id, close }: Props) {
  const [currentValue, setCurrentValue] = useState(MEMBERS_TAB_OPTIONS.ONLINE);

  const CONTENT_COMPONENT_MAP = {
    [MEMBERS_TAB_OPTIONS.ONLINE]: () => (
      <MembersList params={{ id, maxCount: 5 }} query="ONLINE" />
    ),
    [MEMBERS_TAB_OPTIONS.OFFLINE]: () => (
      <MembersList params={{ id }} query="OFFLINE" />
    ),
  };

  return (
    <Card className={styles.container}>
      <Card.Header className={styles.header}>
        <HeaderInfoCard buttonIcon="back" title={'Members'} close={close} />
      </Card.Header>
      <Card.Body className={styles['alt-2-body']}>
        <HTab
          current={currentValue}
          set={setCurrentValue}
          tabOptions={MEMBERS_TAB_OPTIONS}
          tabContent={CONTENT_COMPONENT_MAP}
          tabControlClassName="px-5 py-4 border-y border-dark-gray"
          withoutCloseEffect
        />
      </Card.Body>
    </Card>
  );
}
